<!-- Barre de navigation desktop -->
<div class="w-full bg-noir-1 p-2 text-white items-center gap-2 py-4 hidden md:flex">
  <img class="mr-auto" src="/assets/images/logo/logo_datameal.webp" alt="Logo Datameal"/>

  @if (this.restaurants.length > 1) {
    <mk-button [text]="'page.index.title'|translate" icon="dashboard" link=""/>
  }
  @if (this.selectedRestaurant && this.isLogged && this.selectedRestaurant.is_use_password) {
    <mk-button link="#" [text]="'page.commands-history.title'|translate"
      icon="commande" (click)="this.openCommandsHistory()"/>
  }
  @if (this.selectedRestaurant && this.message !== '') {
    <div class="relative w-fit mr-1 h-full rounded cursor-pointer hover:bg-noir-2-contour py-2 transition border-2 rounded border-noir-2-contour" (click)="this.showRestaurantMessage()">
      <mk-icon-button type="transparent" class="px-2 py-[1px]" useSvg="false" icon="campaign" label=""/>
      <div class="w-2 h-2 bg-rose-1 rounded-full absolute translate-x-1/2 -translate-y-1/2 right-0 top-0"></div>
    </div>
  }
  @if (this.selectedRestaurant && this.isLogged && this.selectedRestaurant.is_use_password && (!this.selectedEnterprise ? false : this.selectedEnterprise.isAcceptPayment)) {
    <div
      class="hover:bg-noir-2-contour cursor-pointer w-fit max-w-none h-[50px] text-sm bg-noir-2 border border-noir-2-contour text-white flex items-center justify-center gap-1 px-3 rounded"
      (click)="this.displayWalletReload()"
      >
      <span class="material-icons fg-gris-1">
        wallet
      </span>
      <p class="font-normal break-keep hidden xl:block">Portefeuille :</p>
      <p class="font-bold">{{ this.currencyFormatted() + "€" }}</p>
    </div>
  }
  <mk-profile-card #desktopProfile
    class="max-w-64"
    [dropdownHtml]="this.profileDrodownHtml"
    [profile]="this.profileDescriptor"
    logoutRelativeUrl="/logout"
    style="height: 50px; "
    [ngStyle]="{'display': this.isLogged ? 'block' : 'none'}"
    [walletAmount]="-1"
    />

    @if (this.selectedRestaurant && !this.isLogged) {
      <mk-button [transparent]="true" class="w-fit relative hidden lg:block" icon="settings" (click)="this.displayChildSettings(this.currentChild)"
        text=""/>
    }
  </div>

  <!-- TOP BAR de navigation Mobile -->
  <div class="w-full bg-noir-1 p-2 text-white flex items-center gap-4 py-4 fixed z-50 md:hidden h-[80px]">
    <img class="mr-auto w-24" src="/assets/images/logo/logo_datameal.webp" alt="Logo Datameal"/>

    @if (this.selectedRestaurant && this.isLogged) {
      <mk-profile-card #mobileProfile [dropdownHtml]="this.profileDrodownHtml"
        [profile]="this.profileDescriptor"
        class="h-[50px] flex-1 w-fit max-w-fit z-100" logoutRelativeUrl="/logout" [walletAmount]="this.selectedEnterprise && this.selectedEnterprise.isAcceptPayment ? this.currency() : -1" [ngStyle]="{'display': this.isLogged && this.selectedRestaurant ? 'block' : 'none'}"/>
    }
  </div>

  <!-- BOTTOM BAR de navigation Mobile -->
  <div class="w-full bg-noir-1 text-white flex items-center fixed z-50 md:hidden bottom-0">
    @if (this.selectedRestaurant !== undefined) {
      <button
        [class.bg-noir-2-contour]="this.url().startsWith('/restaurant/')"
        (click)="this.router.navigateByUrl('/')"
        class="flex-1 h-full flex flex-col py-4 justify-center items-center">
        <svg class="icon w-7 h-6 mx-auto">
          <use [attr.href]="'/assets/images/icons/icons.svg#dashboard'"></use>
        </svg>
        <p class="my-0 py-0 text-xs font-semibold overflow-hidden">
          <span [innerText]="'page.index.title'|translate" class="block"></span>
          <span [innerText]="this.selectedRestaurant.name"
          class="block text-[8px] font-semibold fg-gris-2 leading-none break-word px-2"></span>
        </p>
      </button>
    }
    @if (selectedEnterprise && this.moments.length > 1) {
      <button
        (click)="this.resetSelectedEnterprise()"
        [class.bg-noir-2-contour]="this.url() === '/'"
        class="flex-1 h-full flex flex-col py-2 justify-center items-center">
        <svg class="icon w-6 h-6 mx-auto">
          <use [attr.href]="'/assets/images/icons/icons.svg#restaurants'"></use>
        </svg>
        <p class="my-0 py-0 text-xs font-semibold">Lieu de Consommation</p>
        <span [innerText]="this.selectedEnterprise.name"
        class="block text-[8px] font-semibold fg-gris-2 leading-none break-word px-2"></span>
      </button>
    }
    @if (this.selectedRestaurant !== undefined && this.isLogged) {
      <button (click)="this.displayCartModal()"
        class="flex-1 h-full flex flex-col py-5 justify-center items-center relative"
        [class.bg-noir-2-contour]="this.isMobileCartShowed"
        >
        <span class="material-icons w-6 h-6 mx-auto">
          shopping_cart
        </span>
        <p class="my-0 py-0 text-xs font-semibold w-fit">
          @if (this.cartCount > 0) {
            <span
              class="block w-4 h-4 bg-rose-1 rounded-full absolute left-1/2 translate-x-full top-4 -ml-1 text-white text-center">
              {{this.cartCount > 9 ? '9+' : this.cartCount}}
            </span>
          }
          <span>Panier @if (this.selectedEnterprise && this.selectedEnterprise.isAcceptPayment) {
            <span class="font-semibold fg-gris-2">({{ this.cartTotal|formatNumber }} €)</span>
          }</span>
        </p>
      </button>
    }

  </div>
